<template>
  <div
    class="form-group form-check custom-control custom-checkbox"
    :class="[themes[theme]]"
  >
    <label
      :for="id"
      class="form-check-label custom-control-label text-blue inline-block"
      :class="[themes_labes[theme]]"
    >
      <input
        autocomplete="off"
        class="form-check-input custom-control-input mr-2"
        type="checkbox"
        :id="id"
        :name="name"
        :value="value"
        @change="onChange"
        :checked="state"
        :readonly="readonly"
        :disabled="disabled"
        :required="required"
      />
      <span class="checkmark"></span>

      <slot></slot>
    </label>
  </div>
</template>
<style>
.form-check-label {
  position: relative;
  padding-left: 25px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}

/* Hide the browser's default checkbox */
.form-check-label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.form-check-label .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 17px;
  width: 17px;
  /* background-color: #eee; */
  border: 1px solid #1d3964;
}

/* On mouse-over, add a grey background color */
.form-check-label:hover input ~ .checkmark {
  /* background-color: #ccc; */
  border: 1px solid #1d3964;
}

/* When the checkbox is checked, add a blue background */
.form-check-label input:checked ~ .checkmark {
  /* background-color: #2196F3; */
  border: 1px solid #ee0049;
}

/* Create the checkmark/indicator (hidden when not checked) */
.form-check-label .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.form-check-label input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.form-check-label .checkmark:after {
  left: 4px;
  top: 1px;
  width: 7px;
  height: 10px;
  position: absolute;
  border: solid #ee0049;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>

<script>
export default {
  name: "sp-checkbox",
  data() {
    return {
      themes: {
        default: "",
        form: "",
        dark: "button--dark"
      },
      themes_labes: {
        default: "mb-5",
        default2: "",
        form: "text-blue text-2sm mb-2",
        dark: "button--dark"
      }
    };
  },

  model: {
    prop: "modelValue",
    event: "input"
  },

  props: {
    name: {
      required: true,
      type: String
    },

    id: {
      required: true,
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      required: false,
      type: String,
      default: ""
    },

    modelValue: {
      default: undefined
    },

    checked: {
      required: false,
      type: Boolean,
      default: false
    },

    readonly: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },
    theme: {
      required: false,
      type: String,
      default: ""
    }
  },

  computed: {
    state() {
      if (this.modelValue === undefined) {
        return this.checked;
      }

      if (Array.isArray(this.modelValue)) {
        return this.modelValue.indexOf(this.value) !== -1;
      }

      return this.modelValue === this.value;
    }
  },

  methods: {
    onChange(event) {
      if (this.disabled) return;
      if (this.modelValue !== undefined) {
        let value = this.modelValue;
        if (Array.isArray(value)) {
          value = value.slice();
          const i = value.indexOf(this.value);
          if (i === -1) {
            this.modelValue.push(this.value);
          } else {
            this.modelValue.splice(i, 1);
          }
        } else {
          this.modelValue = !this.state;
          this.$emit("change", this.modelValue);
        }
      }
      this.$emit("input", event.target.checked);
    },

    toggle() {
      this.$emit("input", this.value);
    }
  },

  watch: {
    checked(value) {
      if (value !== this.state) {
        this.toggle();
      }
    }
  },

  mounted() {
    if (this.checked && !this.state) {
      this.toggle();
    }
  }
};
</script>
